import { Component } from '@angular/core';
import { viewerType } from 'ngx-doc-viewer/ngx-doc-viewer/src/lib/document-viewer.component';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

import { DocumentViewerDialogData } from './document-viewer-dialog.data';

@Component({
	selector: 'spr-document-viewer-dialog',
	templateUrl: './document-viewer-dialog.component.html',
	host: {
		class: 'block',
		style: 'height: 70vh;',
	},
})
export class DocumentViewerDialogComponent {
	public viewer: viewerType;
	public documentUrl: string;

	constructor(config: DynamicDialogConfig) {
		const data: DocumentViewerDialogData = config.data;
		this.viewer = /\.(jpeg|jpg|png|gif|webm|bmp)/g.test(data.url)
			? 'url'
			: data.url.includes('.docx')
			? 'office'
			: 'google';
		this.documentUrl = data.url;
	}
}
